import React from 'react';
import Navigation from './lp2/Navigation';
import Footer from './lp2/Footer';

const Privacy = () => {
    return (
        <div className="min-h-screen">
            <Navigation />
            
            <section className="py-20 px-4 bg-white">
                <div className="max-w-4xl mx-auto">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                            Datenschutzrichtlinie
                        </h1>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            Wir bei EsGehtMirGut.ch verpflichten uns zum Schutz Ihrer Privatsphäre.
                        </p>
                    </div>

                    <div className="prose prose-lg max-w-none">
                        <div className="bg-white rounded-lg shadow-sm border p-8">
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Einführung</h3>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                Wir bei EsGehtMirGut.ch verpflichten uns zum Schutz Ihrer Privatsphäre. Diese Datenschutzrichtlinie gilt für alle unsere Dienstleistungen, die über unsere App zugänglich sind. Durch die Nutzung unserer App stimmen Sie der Sammlung, Übertragung, Verarbeitung, Speicherung, Offenlegung und anderen Verwendungsarten Ihrer Informationen gemäss dieser Datenschutzrichtlinie zu.
                            </p>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Informationssammlung und Nutzung</h3>
                            <p className="text-gray-700 mb-4 leading-relaxed">
                                Um unsere Dienste bereitzustellen und zu verbessern, erfassen wir Informationen, die Sie uns zur Verfügung stellen, einschliesslich, aber nicht beschränkt auf:
                            </p>
                            <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
                                <li><strong>Persönliche Identifikationsinformationen:</strong> Name, WhatsApp-Nummer und andere Kontaktdaten.</li>
                                <li><strong>Nutzungsdaten:</strong> Informationen darüber, wie Sie den Dienst nutzen, einschliesslich Zugriffszeiten und gesendete Nachrichten.</li>
                            </ul>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Teilen und Offenlegen von Informationen</h3>
                            <p className="text-gray-700 mb-4 leading-relaxed">
                                Wir geben Ihre persönlichen Daten nicht an Dritte weiter, ausser in folgenden Fällen:
                            </p>
                            <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
                                <li><strong>Zur Bereitstellung des Dienstes:</strong> Wir teilen Ihre WhatsApp-Nummer mit WhatsApp, einem Dienst von Facebook, Inc., um die Nachrichtenübermittlung zu ermöglichen.</li>
                                <li><strong>Rechtliche Anforderungen:</strong> Wenn wir gesetzlich dazu verpflichtet sind oder wenn es notwendig ist, um unsere Rechte zu schützen.</li>
                            </ul>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Datenspeicherung und Sicherheit</h3>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                Wir ergreifen angemessene Massnahmen, um Ihre persönlichen Daten vor unbefugtem Zugriff oder unbefugter Offenlegung zu schützen. Ihre Daten werden so lange aufbewahrt, wie es für die Bereitstellung unserer Dienste erforderlich ist, oder um gesetzlichen Verpflichtungen nachzukommen.
                            </p>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Ihre Datenschutzrechte</h3>
                            <p className="text-gray-700 mb-4 leading-relaxed">
                                Als Nutzer unserer App haben Sie das Recht:
                            </p>
                            <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
                                <li>Auskunft über die von uns gespeicherten persönlichen Daten zu verlangen.</li>
                                <li>Berichtigung unrichtiger Daten zu verlangen.</li>
                                <li>Löschung Ihrer persönlichen Daten zu verlangen.</li>
                                <li>Bitte kontaktieren Sie uns, wenn Sie eines Ihrer Rechte ausüben möchten.</li>
                            </ul>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Änderungen an dieser Datenschutzrichtlinie</h3>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                Wir können diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. Änderungen werden auf unserer Website und/oder App bekannt gegeben. Ihre fortgesetzte Nutzung unseres Dienstes nach solchen Änderungen stellt Ihre Zustimmung zu den aktualisierten Richtlinien dar.
                            </p>
                            
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Kontakt</h3>
                            <p className="text-gray-700 mb-4 leading-relaxed">
                                Bei Fragen oder Bedenken bezüglich dieser Datenschutzrichtlinie kontaktieren Sie uns bitte unter: 
                                <a href="mailto:office@hankeconsulting.ch" className="text-blue-600 hover:text-blue-800 ml-1">
                                    office@hankeconsulting.ch
                                </a>
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                EsGehtMirGut.ch, Buchenegg 25, 8143 Stallikon, Schweiz
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Privacy;
